import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a3d45bc6")

_pushScopeId("data-v-a3d45bc6")
const _hoisted_1 = { class: "new-join-view" }
const _hoisted_2 = { class: "funicebreaker-new-game flex flex-column items-stretch" }
const _hoisted_3 = { class: "mb2" }
const _hoisted_4 = {
  key: 0,
  class: "input-wrapper"
}
const _hoisted_5 = {
  key: 1,
  class: "input-wrapper"
}
const _hoisted_6 = { class: "input-wrapper--checkbox mt3" }
const _hoisted_7 = { class: "input-wrapper--checkbox" }
const _hoisted_8 = {
  key: 2,
  class: "input-wrapper"
}
const _hoisted_9 = {
  key: 3,
  class: "input-wrapper"
}
const _hoisted_10 = { for: "name" }
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}
const _hoisted_12 = {
  key: 4,
  class: "input-wrapper"
}
const _hoisted_13 = { for: "nickname" }
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = {
  key: 5,
  class: "input-wrapper"
}
const _hoisted_16 = { for: "job" }
const _hoisted_17 = {
  key: 0,
  class: "p-error"
}
const _hoisted_18 = {
  key: 6,
  class: "input-wrapper"
}
const _hoisted_19 = {
  key: 0,
  class: "funicebreaker-new-game__avatars"
}
const _hoisted_20 = { class: "estimate estimate-label" }
const _hoisted_21 = { class: "estimate" }
const _hoisted_22 = { class: "estimate" }
const _hoisted_23 = { class: "estimate" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LogoSpinner = _resolveComponent("LogoSpinner")!
  const _component_IconAttribute = _resolveComponent("IconAttribute")!
  const _component_LanguageSelection = _resolveComponent("LanguageSelection")!
  const _component_Button = _resolveComponent("Button")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_DropdownSelect = _resolveComponent("DropdownSelect")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Input = _resolveComponent("Input")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LogoSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_IconAttribute, { white: true }),
        _createVNode(_component_LanguageSelection, { class: "language-selection" }),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => {
            _ctx.selectQuestionsManually = !_ctx.selectQuestionsManually;
            _ctx.selectedQuestions = [];
          })
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.selectQuestionsManually
              ? _ctx.$t('newGame.selectAutomatically')
              : _ctx.$t('newGame.selectManually')), 1)
            ]),
            _: 1
          })
        ]),
        (_ctx.selectQuestionsManually)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("label", null, [
                _createVNode("b", null, _toDisplayString(_ctx.$t('newGame.questions')) + "*", 1)
              ]),
              _createVNode(_component_MultiSelect, {
                modelValue: _ctx.selectedQuestions,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedQuestions = $event)),
                options: _ctx.questions,
                optionLabel: _ctx.$i18n.locale === 'pl' ? 'textPl' : 'textEn',
                placeholder: _ctx.$t('newGame.selectedQuestions')
              }, null, 8, ["modelValue", "options", "optionLabel", "placeholder"])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("label", null, [
                _createVNode("b", null, _toDisplayString(_ctx.$t('newGame.numberOfQuestions')) + "*", 1)
              ]),
              _createVNode(_component_DropdownSelect, {
                modelValue: _ctx.noOfQuestionsLeft,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.noOfQuestionsLeft = $event)),
                options: 
            [3, 4, 5, 6, 7, 8, 9, 10].map(item => ({
              label: item,
              value: item
            }))
          ,
                "option-label": "label",
                "option-value": "value"
              }, null, 8, ["modelValue", "options"])
            ])),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Checkbox, {
            id: "creatorShouldPlayGame",
            modelValue: _ctx.creatorShouldPlayGame,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.creatorShouldPlayGame = $event)),
            binary: true
          }, null, 8, ["modelValue"]),
          _createVNode("label", null, _toDisplayString(_ctx.$t('newGame.playTheGame')), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_Checkbox, {
            id: "limitNumberOfMatching",
            modelValue: _ctx.limitNumberOfMatching,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.limitNumberOfMatching = $event)),
            binary: true
          }, null, 8, ["modelValue"]),
          _createVNode("label", null, _toDisplayString(_ctx.$t('newGame.limitNumberOfMatching')), 1)
        ]),
        (_ctx.limitNumberOfMatching)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("label", null, _toDisplayString(_ctx.$t('newGame.limitNumberOfMatchingLabel')), 1),
              _createVNode(_component_DropdownSelect, {
                modelValue: _ctx.matchingLimit,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.matchingLimit = $event)),
                options: 
            Array.from({ length: 6 }, (v, i) => i + 2).map(item => ({
              label: item,
              value: item
            }))
          ,
                "option-label": "label",
                "option-value": "value"
              }, null, 8, ["modelValue", "options"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.creatorShouldPlayGame)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode("label", _hoisted_10, [
                _createVNode("b", null, _toDisplayString(_ctx.$t('newGame.name')) + "*", 1)
              ]),
              _createVNode(_component_Input, {
                id: "name",
                type: "text",
                modelValue: _ctx.name,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.name = $event))
              }, null, 8, ["modelValue"]),
              (_ctx.name.length >= 25)
                ? (_openBlock(), _createBlock("small", _hoisted_11, _toDisplayString(_ctx.$t('warnings.cantBeLongerThan', { value: 25 })), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.creatorShouldPlayGame)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('newGame.nickname')), 1),
              _createVNode(_component_Input, {
                id: "nickname",
                type: "text",
                modelValue: _ctx.nickname,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.nickname = $event))
              }, null, 8, ["modelValue"]),
              (_ctx.nickname.length >= 25)
                ? (_openBlock(), _createBlock("small", _hoisted_14, _toDisplayString(_ctx.$t('warnings.cantBeLongerThan', { value: 25 })), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.creatorShouldPlayGame)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('newGame.job')), 1),
              _createVNode(_component_Input, {
                id: "job",
                type: "text",
                modelValue: _ctx.job,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.job = $event))
              }, null, 8, ["modelValue"]),
              (_ctx.job.length >= 25)
                ? (_openBlock(), _createBlock("small", _hoisted_17, _toDisplayString(_ctx.$t('warnings.cantBeLongerThan', { value: 25 })), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.creatorShouldPlayGame)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _createVNode("label", null, [
                _createVNode("b", null, _toDisplayString(_ctx.$t('newGame.chooseAvatar')) + "*", 1)
              ]),
              (_ctx.avatars && _ctx.avatars.list)
                ? (_openBlock(), _createBlock("div", _hoisted_19, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.avatars.list, (avatar) => {
                      return (_openBlock(), _createBlock("img", {
                        key: avatar,
                        class: ["funicebreaker-new-game__avatars-item", {
              'funicebreaker-new-game__avatars-item--selected': avatar === _ctx.selectedAvatar?.name
            }],
                        src: require(`@/assets/avatars/${_ctx.avatars.name}/${avatar}.svg`),
                        onClick: ($event: any) => (_ctx.selectedAvatar = { pack: _ctx.avatars.name, name: avatar })
                      }, null, 10, ["src", "onClick"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.addGame
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.newGameLoading ? _ctx.$t('common.loading') : _ctx.$t('newGame.startNewGame')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('newGame.estimatedGameTimeIs')), 1),
        _createVNode("div", _hoisted_21, [
          _createTextVNode(_toDisplayString(_ctx.$t('newGame.for')) + " 3-5 " + _toDisplayString(_ctx.$t('newGame.players')) + ": ", 1),
          _createVNode("b", null, _toDisplayString(_ctx.estimatedDuration.threeFive) + " " + _toDisplayString(_ctx.$t('newGame.estimatedMinutes')), 1)
        ]),
        _createVNode("div", _hoisted_22, [
          _createTextVNode(_toDisplayString(_ctx.$t('newGame.for')) + " 6-8 " + _toDisplayString(_ctx.$t('newGame.players')) + ": ", 1),
          _createVNode("b", null, _toDisplayString(_ctx.estimatedDuration.sixEight) + " " + _toDisplayString(_ctx.$t('newGame.estimatedMinutes')), 1)
        ]),
        _createVNode("div", _hoisted_23, [
          _createTextVNode(_toDisplayString(_ctx.$t('newGame.for')) + " " + _toDisplayString(_ctx.$t('newGame.moreThanEight')) + ": ", 1),
          _createVNode("b", null, _toDisplayString(_ctx.estimatedDuration.moreThanEight) + " " + _toDisplayString(_ctx.$t('newGame.estimatedMinutes')), 1)
        ])
      ])
    ])
  ], 64))
})